'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var RuntimeOptions = require('../RuntimeOption.js');
var linkHelper = require('../common/LinkHelper');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper.js');
var graphicsHelper = require('./../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');
/*
 @Author : allen
 @CreateDate : 2017-8-21
 @Descript : 格子中单个子项
 */
var Group = React.createClass({
  actionData: {},
  render: function () {
    if(this.props.interactiveData || this.props.links) {
      this.actionData = linkHelper.parseComInteractive(this.props)[0];
    }
    var haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
    var isLink = this.actionData.externalURL || this.actionData.link;
    var className = 'no-link';
    var linkStyle = {
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      userSelect: 'none',
      position: 'absolute',
      //此处链接区域应该置于上层
      //注意检查：改动该属性是否有副作用
      zIndex: 800,
      pointerEvents: 'none'
    };
    if (haveAction) {
      if (isLink) {
        className = 'page-link'
      } else {
        className = 'interactive-link'
      }
    }
    return (<div
      className="component component-Group"
      style={{
        cursor:haveAction?'pointer':'default',
        overflow: 'hidden'
      }}
      onClick={this._onClick}
      onMouseDown={this._onMouseDown}
      onMouseUp={this._onMouseUp}
      onDoubleClick={this._onDblClick}
      onContextMenu={this._onContentMenu}
    >
      {
        haveAction && (
          <div className={className}
               style={linkStyle}

          ></div>
        )
      }
      <div style={{position:'absolute',zIndex:1}}>
        {this.props.children}
      </div>
    </div>);
  },

  _onContentMenu: function (e) {
    e.nativeEvent.returnValue = false;
    return false;
  },

  _onLinkEvent: function (evt, linkKey) {
    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
  },

  _onClick: function (e) {
    var key;
    if (this.longPress) {
      return;
    }
    if (e.button === 0) {
      if (this.actionData.externalURL) {
        key = appTypes.ActionResponseType.OUTER;
      } else if (this.actionData.link) {
        key = appTypes.ActionResponseType.LINK;
      } else if (this.actionData.entry) {
        key = appTypes.ActionResponseType.INTERACTIVE;
      }
      if (key) {
        this._onLinkEvent(e, key);
      }
    } else if (e.button === 2) {
      this._onRightClick(e);
    }
  },

  _onLongPress: function (evt) {
    if (this.props.events.doSelfLongPress)
      this.props.events.doSelfLongPress(evt, this.props, 0)
  },

  _onRightClick: function (evt) {
    if (this.props.events.doSelfRightClick) {
      this.props.events.doSelfRightClick(evt, this.props, 0);
    }
  },

  _onDblClick: function (evt) {
    if (this.props.events.doSelfDbClick) {
      this.props.events.doSelfDbClick(evt, this.props, 0);
    }
  },

  _onMouseDown: function (e) {
    if (e.button === 0) {
      this.mousePress = true;
      this._startLongPress(e);
    }
  },

  _onMouseUp: function (e) {
    this.mousePress = false;
    this._stopLongPress();
  },
  _startLongPress: function (e) {
    var self = this;
    self.longPress = false;
    if(linkHelper.hasLongPressEvents(this.props.interactiveData,0)) {
      this.longPressTimeID = setTimeout(function () {
        if (self.mousePress) {
          self.longPress = true;
          self._onLongPress(e);
        }
        self._stopLongPress();
      }, 800);
    }
  },

  _stopLongPress: function () {
    if (this.longPressTimeID) {
      clearTimeout(this.longPressTimeID)
    }
    delete this.longPressTimeID;
  }
});

module.exports = Group;



// WEBPACK FOOTER //
// ./src/views/Components/RepeaterItem.jsx